const FILTER_CARD_STATES = Object.freeze({
   SELECT: 'filter-select',
   EDIT: 'filter-edit',
   NEW: 'filter-new',
});

export default FILTER_CARD_STATES;
